export const updateSlidesMetaData = ({
	title,
	shareLink,
	shareOption,
	accessCode,
	link,
	id,
}) => ({
	type: "UPDATE_SLIDES_META_DATA",
	title,
	shareLink,
	shareOption,
	accessCode,
	link,
	id,
});
